import { AnimationClock } from './AnimationClock'

/** The single animation clock shared by the map and the controls. */
export const clock = new AnimationClock()
